import type { StateCreator } from 'zustand';
import type { PresenceSlice, WhatsAppChatStore, ContactPresence } from '../types';

export const createPresenceSlice: StateCreator<
  WhatsAppChatStore,
  [],
  [],
  PresenceSlice
> = (set, get) => ({
  presenceMap: new Map(),
  lidToCusMap: new Map(),

  saveLidMapping: (lid: string, cus: string) => {
    const { lidToCusMap } = get();
    if (lidToCusMap.get(lid) === cus) return; // già presente

    const newMap = new Map(lidToCusMap);
    newMap.set(lid, cus);

    // Persist in localStorage
    try {
      localStorage.setItem('whatsapp_lid_map', JSON.stringify([...newMap]));
    } catch {
      // Ignore storage errors
    }

    set({ lidToCusMap: newMap });
  },

  updatePresence: (chatId: string, presence: ContactPresence) => {
    const { presenceMap, lidToCusMap } = get();

    // Normalizza chatId: @lid (linked device) -> @c.us
    let normalizedChatId = chatId;

    if (chatId.endsWith('@lid')) {
      const mappedCus = lidToCusMap.get(chatId);
      if (mappedCus) {
        normalizedChatId = mappedCus;
      }
      // Se non c'è mapping, mantieni l'id @lid originale — NON assumere sia la chat aperta.
      // L'indicatore resterà sotto una chiave @lid che non matcha nessuna chat visualizzata,
      // evitando che il typing di un'altra chat appaia in quella corrente.
    }

    const newMap = new Map(presenceMap);
    const presenceEntry = { ...presence, chatId: normalizedChatId };
    newMap.set(normalizedChatId, presenceEntry);
    // Salva anche sotto la chiave originale @lid per match con selectedChatId
    // (selectedChatId può essere @lid quando WAHA 2026.3.x invia tutto come @lid)
    if (chatId !== normalizedChatId) {
      newMap.set(chatId, presenceEntry);
    }
    set({ presenceMap: newMap });
  },
});
